// Index admin tarafındaki Apple DEP modelleri.
// Bayi tarafıyla paylaşılan tipler MySpecial/AppleDep/models/models.ts içinde.

export interface IAppleDepDealerSettings {
  Id: number
  DealerCode: string
  DealerName?: string
  /** Device Enrollment Facilitation Agreement kabul tarihi (yyyy-MM-dd). */
  AgreementAcceptedOn?: string
  /** EndCustomer / DealerOwn / Both — cihaz hangi ABM hesabına kaydedilecek? */
  OrganizationIdMode?: string
  /** Bayinin kendi Apple Business Manager Organization ID'si. */
  OwnOrganizationId?: string
  OwnOrganizationName?: string
  Active: boolean
  Note?: string
}

/** Admin ekranındaki Organization ID modu seçenekleri. */
export const AppleDepOrganizationIdModeOptions = [
  {
    value: 'EndCustomer',
    label: 'Son kullanıcıdan alınır',
    description:
      'Bayi, her müşterisinin Apple Business Manager Organization ID bilgisini kendi girer. Cihazlar son kullanıcının hesabına kaydedilir.',
  },
  {
    value: 'DealerOwn',
    label: 'Bayinin kendi kurumu',
    description:
      'Cihazlar bayinin kendi Apple Business Manager hesabına kaydedilir. Bayi müşteri tanımı yapmaz.',
  },
  {
    value: 'Both',
    label: 'İkisi de (bayi seçer)',
    description:
      'Bayi her atamada cihazı kendi kurumuna mı yoksa son kullanıcısının hesabına mı kaydedeceğini seçer.',
  },
]

export interface IAppleDepApiLog {
  Id: number
  AppleDepTransactionId?: number
  DealerCode?: string
  /** BulkEnroll / CheckTransactionStatus / ShowOrderDetails */
  ApiName: string
  RequestUrl?: string
  RequestJson?: string
  ResponseJson?: string
  HttpStatusCode?: number
  DurationMs?: number
  IsSuccess: boolean
  IsLive: boolean
  IsFake: boolean
  ExceptionMessage?: string
  LogWhen: string
}

// --- Show Order Details yanıtı (Apple alan adları camelCase) ---

export interface IAppleDepShowOrderDevice {
  deviceId: string
  assetTag?: string
}

export interface IAppleDepShowOrderDelivery {
  deliveryNumber: string
  shipDate?: string
  devices?: IAppleDepShowOrderDevice[]
}

export interface IAppleDepShowOrder {
  orderNumber: string
  orderDate?: string
  orderType?: string
  customerId?: string
  poNumber?: string
  showOrderStatusCode?: string
  showOrderStatusMessage?: string
  deliveries?: IAppleDepShowOrderDelivery[]
}

export interface IAppleDepShowOrderDetailsResponse {
  orders?: IAppleDepShowOrder[]
  statusCode?: string
  respondedOn?: string
}
